// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitInformation_unit-information__2tAx0 {
  margin-bottom: 10px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_title__Stxz2 {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_title__Stxz2 p {
  font-size: 20px;
  font-weight: 600;
  margin-right: 15px !important;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_info__2VvpI {
  margin-bottom: 15px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_info__2VvpI .UnitInformation_statistic__abo8v {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_info__2VvpI .UnitInformation_statistic__abo8v svg {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_info__2VvpI .UnitInformation_statistic__abo8v p {
  font-size: 14px;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_info__2VvpI .UnitInformation_statistic__abo8v span {
  font-weight: 600;
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_detail__MgRN1 button {
  padding: 10px 15px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  background: white;
  color: var(--dark-grey);
}
.UnitInformation_unit-information__2tAx0 .UnitInformation_detail__MgRN1 button:hover {
  cursor: pointer;
  border: 1px solid var(--explore-color);
  color: var(--explore-color);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/UnitInformation/UnitInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;AADI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAGN;AAAE;EACE,mBAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAIR;AAFM;EACE,eAAA;AAIR;AAFM;EACE,gBAAA;AAIR;AACI;EACE,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;EACA,uBAAA;AACN;AACI;EACE,eAAA;EACA,sCAAA;EACA,2BAAA;AACN","sourcesContent":[".unit-information {\n  margin-bottom: 10px;\n  .title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n    p {\n      font-size: 20px;\n      font-weight: 600;\n      margin-right: 15px !important;\n    }\n  }\n  .info {\n    margin-bottom: 15px;\n    .statistic {\n      display: flex;\n      align-items: center;\n      margin-bottom: 5px;\n      svg {\n        width: 18px;\n        height: 18px;\n        margin-right: 10px;\n      }\n      p {\n        font-size: 14px;\n      }\n      span {\n        font-weight: 600;\n      }\n    }\n  }\n  .detail {\n    button {\n      padding: 10px 15px;\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      background: white;\n      color: var(--dark-grey);\n    }\n    button:hover {\n      cursor: pointer;\n      border: 1px solid var(--explore-color);\n      color: var(--explore-color);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-information": `UnitInformation_unit-information__2tAx0`,
	"title": `UnitInformation_title__Stxz2`,
	"info": `UnitInformation_info__2VvpI`,
	"statistic": `UnitInformation_statistic__abo8v`,
	"detail": `UnitInformation_detail__MgRN1`
};
export default ___CSS_LOADER_EXPORT___;
